

















































































































import { Vue, Component } from "vue-property-decorator";
import Address from "@/zh-website/src/components/website/Address.vue";
import ReadTo from "@/zh-website/src/views/partner/supplier/ReadTo.vue";
import { PartnerService } from "@/zh-website/src/views/partner/service";
import { RegService } from "@common/service/base-service/reg";
import Vcode from "@common/components/puzzle-vcode";
import { ICTLoginService } from "@common/ict/service/data-service/login";

@Component({
  components: {
    Address,
    ReadTo,
    Vcode
  }
})
export default class ProjectReport extends Vue {
  imgs = [
    require("@common/assets/slider-1.png"),
    require("@common/assets/slider-2.png"),
    require("@common/assets/slider-3.png"),
    require("@common/assets/slider-4.png")
  ];
  fgImg = "";
  fgY = 0;
  fgX = 0;
  VCID = "";
  isShowSlider = false;
  isSliderSuccess = false;

  timer: any = null;
  countDown = 0;
  isCheck = false;
  isSuccess = false;

  projectTypeList = [{
    label: "产教融合实践中心",
    value: "1"
  }, {
    label: "产业学院",
    value: "2"
  }, {
    label: "人社公共实训基地",
    value: "3"
  }, {
    label: "现场工程师学院",
    value: "4"
  }, {
    label: "5G+数字化人才培养基地项目",
    value: "5"
  }, {
    label: "校企合作专业共建",
    value: "6"
  }, {
    label: "工信根技术基地",
    value: "7"
  }, {
    label: "其他",
    value: "8"
  }]

  reportForm = {
    reporterCompanyName: "",
    reporterName: "",
    reporterPosition: "",
    reporterEmail: "",
    projectName: "",
    projectAddress: {
      province: "",
      city: "",
      district: "",
      detail: ""
    },
    projectType: "",
    projectStage: "",
    projectDescription: "",
    projectBillDate: "",
    projectBillAmount: "",
    projectBackground: "",
    clientCompanyName: "",
    clientAddress: {
      province: "",
      city: "",
      district: "",
      detail: ""
    },
    clientContactName: "",
    clientContactPhone: ""
  };

  reportRules = {
    reporterCompanyName: [
      { 
        required: true,
        message: "请输入伙伴公司名",
        trigger: ["change", "blur"]
      }
    ],
    reporterName: [
      {
        required: true,
        message: "请输入您的名字",
        trigger: ["change", "blur"]
      }
    ],
    reporterPosition: [
      {
        required: true,
        message: "请输入您的职位",
        trigger: ["change", "blur"]
      }
    ],
    reporterEmail: [
      {
        required: true,
        message: "请输入您的工作邮箱",
        trigger: ["change", "blur"]
      },
      {
        pattern: RegService.EMAIL, 
        message: "邮件格式错误"
      }
    ],
    projectName: [
      {
        required: true,
        message: "请输入此次报备的项目名称",
        trigger: ["change", "blur"]
      }
    ],
    projectAddress: [
      {
        required: true,
        message: "请选择所在省份",
        trigger: ["change", "blur"]
      }, {
        validator: this.validateAddress,
        message: "请选择所在省份",
        trigger: ["change", "blur"]
      }
    ],
    projectType: [
      {
        required: true,
        message: "请选择项目类型",
        trigger: ["change", "blur"]
      }
    ],
	  projectStage: [
      {
        required: true,
        message: "请输入项目期次",
        trigger: ["change", "blur"]
      },

    ],
	  projectDescription: [
      {
        required: true,
        message: "请输入补充说明",
        trigger: ["change", "blur"]
      }
    ],
	  projectBillDate: [
      {
        required: true,
        message: "请选择预计签单日期",
        trigger: ["change", "blur"]
      }
    ],
	  projectBillAmount: [
      {
        required: true,
        message: "请输入华为预计签单金额",
        trigger: ["change", "blur"]
      },
      {
        validator: this.validateNumber,
        message: "请输入正数",
        trigger: ["change", "blur"]
      }
    ],
	  projectBackground: [
      {
        required: true,
        message: "请输入项目背景",
        trigger: ["change", "blur"],
      }
    ],
	  clientCompanyName: [
      {
        required: true,
        message: "请输入客户名称",
        trigger: ["change", "blur"]
      }
    ],
	  clientAddress: [
      {
        required: true,
        message: "请选择客户所在地",
        trigger: ["change", "blur"]
      }, {
        validator: this.validateAddress,
        message: "请选择客户所在地",
        trigger: ["change", "blur"]
      }
    ],
	  clientContactName: [
      {
        required: true,
        message: "请输入客户联系人姓名",
        trigger: ["change", "blur"]
      }
    ],
	  clientContactPhone: [
      {
        required: true,
        message: "请输入客户联系人手机号码",
        trigger: ["change", "blur"]
      },
      {
        pattern: RegService.PHONE, 
        message: "手机号码格式错误"
      }
    ]
  };

  validateAddress(rule, value, callback) {
    if (value.province == "") {
      callback(new Error(rule.message));
    } else {
      callback();
    }
  }

  validateNumber(rule, value, callback) {
    if (!isNaN(parseFloat(value)) && isFinite(value) && parseFloat(value) > 0) {
      callback();
    } else {
      callback(new Error(rule.message));
    }
  }

  updateProjectAddress(data) {
    console.log("update project address");
    this.reportForm.projectAddress = data;
    
  }

  updateClientAddress(data) {
    console.log("update client address", data);
    this.reportForm.clientAddress = data;
  }

  submitReport() {
    console.log("submit report");
    (this.$refs['reportForm'] as any).validate(valid => {
        if (valid) {
          if (!this.isCheck) {
            this.$message.error("请仔细阅读并同意隐私协议");
            return false;
          }

          if (!this.isSliderSuccess) {
            this.getSlideInfo();
          } else {
            this.closeSliderLogin();
            const params = Object.assign(this.reportForm, {
              projectProvince: this.reportForm.projectAddress.province,
              projectCity: this.reportForm.projectAddress.city,
              clientProvince: this.reportForm.clientAddress.province,
              clientCity: this.reportForm.clientAddress.city,
              verificationCodeId: this.VCID,
              y: this.fgY,
              x: this.fgX
            });

            PartnerService.addReport(params).then((res: any) => {
              if (res.success) {
                this.isSuccess = true;
                this.reportForm = {
                  reporterCompanyName: "",
                  reporterName: "",
                  reporterPosition: "",
                  reporterEmail: "",
                  projectName: "",
                  projectAddress: {
                    province: "",
                    city: "",
                    district: "",
                    detail: ""
                  },
                  projectType: "",
                  projectStage: "",
                  projectDescription: "",
                  projectBillDate: "",
                  projectBillAmount: "",
                  projectBackground: "",
                  clientCompanyName: "",
                  clientAddress: {
                    province: "",
                    city: "",
                    district: "",
                    detail: ""
                  },
                  clientContactName: "",
                  clientContactPhone: ""
                };
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
            return false;
        }
    });
  }

  // 滑块验证失败
  failSliderLogin(err) {
    this.$message.warning("滑块验证失败");
    this.closeSliderLogin();
  }

  async checkVerifyCode({ x, y }) {
    this.fgX = x;
    return ICTLoginService.checkSliderRes({
      verificationCodeId: this.VCID,
      isDeleteAfterSuccess: false,
      x,
      y
    }).then((res: any) => {
      if (!res) {
        throw new Error();
      }
      return res;
    });
  }
  successSliderLogin(res) {
    if (res) {
      this.isSliderSuccess = true;
      this.submitReport();
    }
  }
  getSlideInfo() {
    ICTLoginService.getVerifyCode().then(res => {
      if (res) {
        this.imgs = [res.shadeImage];
        this.fgImg = res.cutoutImage;
        this.fgY = res.y;
        this.VCID = res.verificationCodeId;
        // 显示登录右滑拼图验证
        this.isShowSlider = true;
      }
    });
  }

  closeSliderLogin() {
    this.isShowSlider = false;
    this.isSliderSuccess = false;
  }
}
